import { render } from "./BotsDropdown.vue?vue&type=template&id=14ea4d50&scoped=true"
import script from "./BotsDropdown.vue?vue&type=script&lang=js"
export * from "./BotsDropdown.vue?vue&type=script&lang=js"

import "./BotsDropdown.vue?vue&type=style&index=0&id=14ea4d50&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ea4d50"]])

export default __exports__